import script from "./HomepageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HomepageTable.vue?vue&type=script&setup=true&lang=js"

import "./HomepageTable.vue?vue&type=style&index=0&id=74d5dace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d5dace"]])

export default __exports__